import api from "../api/axios";

const NotificationService = {
  // Aktif bildirimleri listele (Kullanıcı için)
  getUserNotifications: () => api.get("SystemNotification/user-list"),

  // Bildirimi okundu olarak işaretle
  markAsRead: (id) => api.post(`SystemNotification/${id}/read`),

  // Sistem bildirimlerini listele (Admin için)
  getAdminNotifications: () => api.get("SystemNotification/admin-list"),

  // Bildirimi kimlerin okuduğunu listele (Admin için)
  getReadDetails: (notificationId) => api.get(`SystemNotification/read-details/${notificationId}`),

  // Yeni bildirim gönder (Admin için)
  createNotification: (data) => api.post("SystemNotification", data)
};

export default NotificationService;
